/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useState } from 'react'

import { Delete } from '../../icons'
import { CustomDialog } from '../index'
import { Input } from '../inputs'
import { LinkComponent } from '../link-component'
import { Styled } from './styled'

export const CompanyTab = ({
  companyName,
  companyId,
  companyNameChange,
  deleteCompany
}) => {
  const deleteCompanyHandler = () => deleteCompany(companyId)
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(false)
  const [tempCompanyName, setTempCompanyName] = useState(companyName)
  const onBlurHandler = useCallback(() => {
    // eslint-disable-next-line lodash/prefer-lodash-method
    if (tempCompanyName.trim()) {
      companyNameChange(tempCompanyName)
    } else (
      setTempCompanyName(companyName)
    )
  }, [tempCompanyName, companyName, companyNameChange]);
  return (
    <Styled.Company>
      <Input
        width={'100%'}
        type="text"
        text={'Title'}
        input={{
          value: tempCompanyName,
          onChange: e => setTempCompanyName(e.target.value),
          onBlur: onBlurHandler,
          disabled: !companyNameChange
        }}
      />
      {deleteCompany &&
        <Styled.DeleteCompanyButton>
          <LinkComponent
            text={'Delete Company'}
            Icon={Delete}
            onClick={() => setShowConfirmPopUp(true)}
            mood={'negative'}
          />
        </Styled.DeleteCompanyButton>
      }
      {showConfirmPopUp &&
        <CustomDialog
          mainText={'Delete your company'}
          secondaryText={'The action cannot be undone'}
          onSubmit={() => {
            deleteCompanyHandler()
            setShowConfirmPopUp(false)
          }}
          onReject={() => setShowConfirmPopUp(false)}
        />
      }
    </Styled.Company>
  )
}
